import React, { useEffect, useState } from "react";
import "./Payment_Summary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faTags, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Offcanvas } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Green_Btn from "../../../../../../Common-Component/common_btn/green_btn/Green_Btn";
import Coupon_Card from "../../../../../../Common-Component/coupon_card/Coupon_Card";
import {
  CartCalculation,
  getCart,
} from "../../../../../../../utils/apis/addToCart/addToCart";

const Payment_Summary_Order = ({ order }) => {
  return (
    <>
      <div className="payment_summary_div">
        <div className="summary">
          <div className="row-divider">
            <div className="title_div">
              <p>Total no. of items</p>
            </div>
            <div className="qty_div">
              <p>{Number(order?.quantity)} Nos.</p>
            </div>
          </div>

            <div className="row-divider">
            <div className="title_div">
              <p>Payment Mode</p>
            </div>
            <div className="qty_div">
              <p>{order?.order?.payment_mode}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Sub Total</p>
            </div>
            <div className="qty_div">
              <p>₹ {Number(order?.total_selling).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="delivery_title_div">
              <p>
                Delivery Charges
                {/* - <span className="inner_title">Free Delivery</span> */}
              </p>
            </div>
            <div className="qty_div">
              <p>
                ₹{" "}
                {Number(order?.total_delivery_charges).toFixed(2)}
              </p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>GST</p>
            </div>
            <div className="qty_div">
              <p>₹ {Number(order?.total_tax).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Offer Discount</p>
            </div>
            <div className="qty_div">
              <p>₹ {Number(order?.offer_discount).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Coupon Discount</p>
            </div>
            <div className="qty_div">
              <p>₹ {Number(order?.coupon_discount).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Total Addon</p>
            </div>
            <div className="qty_div">
              <p>₹ {Number(order?.total_addon).toFixed(2)}</p>
            </div>
          </div>

          <div className="total_div">
            <div className="row">
              <div className="col-6">
                <div className="total_title_div">
                  <p>Grand Total</p>
                </div>
              </div>
              <div className="col-6">
                <div className="total_qty_div">
                  <p>
                    ₹ {Number(order?.total_amount).toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment_Summary_Order;
